<h6>
  <span style="color: #f49602">&#9679;</span>&nbsp; Please add some genereal information about the PU foam simulation
</h6>

<usimweb-form-input
  placeholder="Simulation name"
  (selectionChange)="blur()"
  (selectionChange)="simulate.name = $event"
  [required]="true">
</usimweb-form-input>

<usimweb-form-input
  placeholder="Simulation time [s]"
  [type]="inputType.FLOAT_NUMBER"
  [value]="simulate.simulationTime"
  [min]="0.1"
  [max]="600"
  (selectionChange)="blur()"
  (selectionChange)="selectionChangedSimTime($any($event))"
  [toolTipText]="simTimeToolTip"
  [required]="true">
</usimweb-form-input>

<usimweb-dropdown
  placeholder="Number of cores"
  [values]="cpus"
  [default]="defaultCpu"
  (selectionChange)="blur()"
  (selectionChange)="simulate.cpus = $event"
  [key]="key"
  [value]="value"
  [required]="true">
</usimweb-dropdown>

<usimweb-form-input
  placeholder="Output time [s]"
  [type]="inputType.FLOAT_NUMBER"
  [value]="simulate.outPutTime"
  [min]="0.1"
  [max]="300"
  (selectionChange)="blur()"
  (selectionChange)="simulate.outPutTime = $event"
  [toolTipText]="outputTimeToolTip"
  [required]="true">
</usimweb-form-input>

<usimweb-dropdown
  placeholder="Simulation & report type"
  [values]="appTypes"
  [key]="key"
  [value]="value"
  [default]="appType"
  (selectionChange)="blur()"
  (selectionChange)="simulate.appType = $event"
  [required]="true"></usimweb-dropdown>

<usimweb-form-input
  placeholder="Estimated credits"
  [type]="inputType.FLOAT_NUMBER"
  [value]="simulate.credits"
  [toolTipText]="creditsToolTip"
  [readonly]="true">
</usimweb-form-input>
